(() => {
  // Vault incorrect-codes page (final weekend, 24 Sep 2026). Server-driven cadence
  // (publishedThrough / nextPublishAt from /api/wall), released clue from /api/state,
  // tried / not-tried search, clue filter, still-possible count. Ledger is drawn in
  // bounded canvas chunks (<=80 rows, <=8000px backing store) for mobile Safari.
  document.documentElement.classList.add('vcp-page');
  const boot = () => document.querySelectorAll('[data-vault-pool]:not([data-ready])').forEach(init);
  function init(root) {
    root.dataset.ready = '1';
    const $ = (s) => root.querySelector(s);
    const board = $('[data-board]'), seed = $('[data-canvas]'), input = $('[data-code-input]'), verdict = $('[data-verdict]');
    const filterWrap = $('[data-filter]'), filterInput = $('[data-filter-input]');
    let items = [], tried = new Set(), hint = null, wall = null, skew = 0, reloadTimer = null;
    root.addEventListener('copy', (e) => e.preventDefault());
    root.addEventListener('contextmenu', (e) => { if (e.target.tagName === 'CANVAS') e.preventDefault(); });
    const fmt = (ms, withDay) => {
      const p = {};
      new Intl.DateTimeFormat('en-AU', { timeZone: 'Australia/Sydney', weekday: 'long', day: 'numeric', month: 'long', hour: 'numeric', minute: '2-digit', hour12: true, timeZoneName: 'short' })
        .formatToParts(new Date(ms)).forEach((x) => { p[x.type] = x.value; });
      const t = p.hour + ':' + p.minute + String(p.dayPeriod || '').toLowerCase().replace(/\s|\./g, '');
      return withDay ? p.weekday + ' ' + p.day + ' ' + p.month + ', ' + t + ' ' + p.timeZoneName : p.weekday + ' ' + t + ' ' + p.timeZoneName;
    };
    const n = (v) => Number(v).toLocaleString('en-AU');
    const prefix = () => (hint && /^\d{1,2}$/.test(String(hint.digits || '')) ? String(hint.digits) : '');
    function renderClue() {
      const el = $('[data-clue]'), p = prefix();
      if (!p) { el.hidden = true; filterWrap.hidden = true; filterInput.checked = false; return; }
      el.hidden = false;
      const slots = p.padEnd(4, '_').split('');
      el.setAttribute('aria-label', 'Clue: the code starts with ' + slots.join(' '));
      $('[data-clue-slots]').innerHTML = slots.map((c) => '<span class="vcp-slot ' + (c === '_' ? 'empty' : 'known') + '">' + (c === '_' ? '<span class="vcp-dash"></span>' : c) + '</span>').join('');
      filterWrap.hidden = false;
    }
    function renderStats() {
      const p = prefix();
      $('[data-total]').textContent = n(items.length);
      const prev = wall && Number(wall.previousPublishedThrough);
      $('[data-new]').textContent = n(Number.isFinite(prev) ? items.filter((x) => x.ts > prev).length : 0);
      if (p) {
        const used = items.filter((x) => x.code.indexOf(p) === 0).length;
        $('[data-remaining]').textContent = n(Math.pow(10, 4 - p.length) - used);
        $('[data-remaining-label]').textContent = 'codes still possible (start with ' + p + ')';
      } else {
        $('[data-remaining]').textContent = n(10000 - items.length);
        $('[data-remaining-label]').textContent = 'unattempted combinations';
      }
    }
    function renderCadence() {
      if (!wall) return;
      const label = $('[data-next-label]'), cad = $('[data-cadence]'), clock = $('[data-next-release] .vcp__clock'), intro = $('[data-intro]'), foot = $('[data-foot]');
      const base = 'Every incorrect combination submitted to the $50K Vault, published in the exact order it was entered.';
      if (wall.cadence === 'final' || !wall.nextPublishAt) {
        label.textContent = 'Final list published';
        clock.style.display = 'none';
        cad.textContent = 'The vault is closed. Every incorrect code is now shown.';
        intro.textContent = base;
        foot.textContent = 'Final list · Codes are displayed visually to protect the integrity of the competition';
        return;
      }
      clock.style.display = '';
      label.textContent = 'Next batch of incorrect codes released in';
      const next = fmt(wall.nextPublishAt);
      cad.textContent = wall.cadence === 'hourly' ? 'Updated every hour, next update ' + next
        : wall.cadence === '6h' ? 'Updated every 6 hours, next update ' + next
        : 'Updated daily at 9:00am, next update ' + next;
      intro.textContent = base + ' ' + (wall.cadence === 'hourly' ? 'New codes are added every hour until the vault closes.'
        : wall.cadence === '6h' ? 'New codes are added every 6 hours.' : 'New codes are added daily at 9:00am Sydney time.');
      foot.textContent = 'Latest snapshot ' + fmt(wall.publishedThrough, true) + ' · Codes are displayed visually to protect the integrity of the competition';
    }
    function renderCloses(state) {
      const el = $('[data-closes]');
      if (state && state.hint && state.closesAtMs && !state.closed) { el.hidden = false; el.textContent = 'Vault closes ' + fmt(state.closesAtMs, true) + '.'; }
      else el.hidden = true;
    }
    const pad = (v) => String(v).padStart(2, '0');
    function tick() {
      if (!wall || !wall.nextPublishAt) return;
      const remaining = Math.max(0, wall.nextPublishAt - (Date.now() + skew)), s = Math.floor(remaining / 1000);
      $('[data-hours]').textContent = pad(Math.floor(s / 3600));
      $('[data-minutes]').textContent = pad(Math.floor((s % 3600) / 60));
      $('[data-seconds]').textContent = pad(s % 60);
      $('[data-next-release] [role="timer"]').setAttribute('aria-label', Math.floor(s / 3600) + ' hours, ' + Math.floor((s % 3600) / 60) + ' minutes and ' + (s % 60) + ' seconds until the next incorrect code release');
      if (!remaining && !reloadTimer) reloadTimer = setTimeout(() => { reloadTimer = null; load(); }, 4000);
    }
    function check() {
      const raw = input.value.replace(/\D/g, '').slice(0, 4);
      if (raw !== input.value) input.value = raw;
      verdict.className = 'vcp-search__verdict';
      if (raw.length < 4) { verdict.textContent = raw.length ? 'Keep going, four digits.' : 'Type any four digits.'; return; }
      const asOf = wall ? fmt(wall.publishedThrough, true) : 'the last update', p = prefix();
      if (tried.has(raw)) { verdict.classList.add('tried'); verdict.innerHTML = "<b>Already tried, don't waste an entry</b>" + raw + ' is on the incorrect code list.'; }
      else if (p && raw.indexOf(p) !== 0) { verdict.classList.add('nomatch'); verdict.innerHTML = "<b>Doesn't match the clue</b>The winning code starts with " + p + '.'; }
      else { verdict.classList.add('fresh'); verdict.innerHTML = '<b>Not tried yet</b>As of ' + asOf + '.'; }
    }
    const path = (c, x, y, w, h, r) => { c.beginPath(); c.roundRect ? c.roundRect(x, y, w, h, r) : c.rect(x, y, w, h); };
    let io = null, chunks = [];
    function release(c) { c.width = 0; c.height = 0; delete c.dataset.painted; }
    function paint(c) {
      if (c.dataset.painted) return;
      const g = chunks[Number(c.dataset.idx)]; if (!g) return;
      c.width = Math.round(g.cssW * g.dpr); c.height = Math.round(g.cssH * g.dpr);
      const ctx = c.getContext('2d'); ctx.setTransform(g.dpr, 0, 0, g.dpr, 0, 0);
      g.list.forEach((it, i) => {
        const x = (i % g.cols) * (g.cellW + g.gap), y = Math.floor(i / g.cols) * (g.cellH + g.gap);
        ctx.fillStyle = 'rgba(255,244,236,.045)'; ctx.strokeStyle = 'rgba(255,244,236,.13)'; ctx.lineWidth = 1;
        path(ctx, x + 0.5, y + 0.5, g.cellW - 1, g.cellH - 1, 8); ctx.fill(); ctx.stroke();
        ctx.fillStyle = 'rgba(255,244,236,.82)';
        ctx.font = '700 ' + Math.max(34, Math.min(52, g.cellH * 0.72)) + 'px VaultLemon,sans-serif';
        ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
        ctx.fillText(it.code, x + g.cellW / 2, y + g.cellH / 2);
        ctx.strokeStyle = 'rgba(251,13,27,.78)'; ctx.lineWidth = 1.7;
        ctx.beginPath(); ctx.moveTo(x + g.cellW * 0.18, y + g.cellH * 0.57); ctx.lineTo(x + g.cellW * 0.82, y + g.cellH * 0.43); ctx.stroke();
      });
      c.dataset.painted = '1';
    }
    function draw() {
      const p = prefix(), only = p && filterInput.checked;
      const list = only ? items.filter((x) => x.code.indexOf(p) === 0) : items;
      const empty = $('[data-empty]');
      empty.style.display = list.length ? 'none' : 'block';
      empty.textContent = only ? 'No published incorrect codes start with ' + p + ' yet.' : 'No incorrect codes have been published yet.';
      if (io) { io.disconnect(); io = null; }
      board.querySelectorAll('canvas[data-ledger-chunk]').forEach((x) => { release(x); x.remove(); });
      chunks = [];
      seed.style.display = 'none';
      if (!list.length) return;
      const cssW = board.clientWidth - (innerWidth <= 720 ? 18 : 28),
        cols = innerWidth <= 540 ? 3 : innerWidth <= 820 ? 4 : innerWidth <= 1100 ? 5 : 8,
        gap = 8, cellW = (cssW - gap * (cols - 1)) / cols, cellH = Math.max(52, Math.min(72, cellW * 0.48)),
        dpr = Math.min(devicePixelRatio || 1, 2),
        rowsPerChunk = 25, perChunk = cols * rowsPerChunk,
        lazy = typeof IntersectionObserver === 'function';
      if (lazy) io = new IntersectionObserver((es) => es.forEach((e) => (e.isIntersecting ? paint(e.target) : release(e.target))), { rootMargin: '1200px 0px' });
      for (let start = 0, idx = 0; start < list.length; start += perChunk, idx++) {
        const chunk = list.slice(start, start + perChunk), rows = Math.ceil(chunk.length / cols),
          cssH = rows * cellH + (rows - 1) * gap, canvas = document.createElement('canvas');
        chunks.push({ list: chunk, cssW, cssH, cols, gap, cellW, cellH, dpr });
        canvas.dataset.ledgerChunk = '1'; canvas.dataset.idx = String(idx); canvas.setAttribute('aria-hidden', 'true');
        canvas.width = 0; canvas.height = 0; canvas.style.height = cssH + 'px';
        board.insertBefore(canvas, empty);
        if (io) io.observe(canvas); else paint(canvas);
      }
    }
    function load() {
      return Promise.all([
        fetch(root.dataset.endpoint, { mode: 'cors', cache: 'no-store' }).then((r) => { if (!r.ok) throw Error('wall ' + r.status); return r.json(); }),
        fetch(root.dataset.state, { mode: 'cors', cache: 'no-store' }).then((r) => r.json()).catch(() => null)
      ]).then(([data, state]) => {
        const pt = Number(data.publishedThrough);
        if (!Number.isFinite(pt)) throw Error('no publishedThrough');
        wall = data;
        skew = Number.isFinite(data.nowMs) ? data.nowMs - Date.now() : 0;
        hint = state && state.hint ? state.hint : null;
        items = (data.items || []).filter((x) => /^\d{4}$/.test(x.code) && Number(x.ts) <= pt)
          .map((x) => ({ code: x.code, ts: Number(x.ts) })).sort((a, b) => a.ts - b.ts);
        tried = new Set(items.map((x) => x.code));
        renderClue(); renderStats(); renderCadence(); renderCloses(state); draw(); check(); tick();
        root.dataset.loaded = '1';
      }).catch(() => {
        const e = $('[data-empty]');
        e.style.display = 'block';
        e.textContent = 'The code ledger is temporarily unavailable. Please check back shortly.';
        seed.style.display = 'none';
      });
    }
    input.addEventListener('input', check);
    filterInput.addEventListener('change', draw);
    let t;
    let lastW = innerWidth;
    addEventListener('resize', () => { if (innerWidth === lastW) return; lastW = innerWidth; clearTimeout(t); t = setTimeout(draw, 160); }, { passive: true });
    setInterval(tick, 1000);
    (document.fonts && document.fonts.load ? document.fonts.load('700 40px VaultLemon').catch(() => {}) : Promise.resolve()).then(load);
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot) : boot();
  document.addEventListener('shopify:section:load', boot);
})();


